/**
 * Query keys for the thread-less (pasted external email) drafts.
 *
 * Hazard: this module MUST stay import-free. Modules on the app's static boot path name these
 * keys, and importing them from the drafts hook instead pulls the whole drafts and send hook tree
 * into the native entry chunk, past the budget `scripts/check-native-bundle.sh` enforces.
 */

/** Every thread-less correspondence's drafts, the marked-sent replies included. */
export const correspondenceDraftsRootKey = ['email-drafts-correspondence'] as const;

export const correspondenceDraftsKey = (correspondenceId: string | null | undefined) =>
  [...correspondenceDraftsRootKey, correspondenceId ?? null] as const;
